import React, { useEffect, useRef } from 'react';
import { ArrowRight } from 'lucide-react';

const HeroSection = ({ config = {} }) => {
  const videoRef = useRef(null);
  
  const heroTitle = config.heroTitle || 'La agencia #1 de OnlyFans';
  const heroSubtitle = config.heroSubtitle || 'Transformamos modelos en marcas rentables. ¡Únete y forma parte del top 0,1 % de creadoras!';
  const heroImage = config.heroImage || 'https://customer-assets.emergentagent.com/job_talentmgmt/artifacts/1uka7rcz_IMG_6781.JPG';

  useEffect(() => {
    if (videoRef.current) {
      const playVideo = async () => {
        try {
          await videoRef.current.play();
          console.log('Video playing successfully');
        } catch (err) {
          console.log('Autoplay prevented, trying again:', err);
          setTimeout(async () => {
            try {
              await videoRef.current.play();
            } catch (e) {
              console.log('Second attempt failed, video will show poster');
            }
          }, 1000);
        }
      };
      
      playVideo();
    }
  }, []);

  const handleWhatsAppClick = (e) => {
    e.preventDefault();
    window.open('https://api.whatsapp.com/send?phone=573011920219&text=Hola,%20quiero%20información%20sobre%20JG%20Models', '_blank');
  };

  return (
    <section id="inicio" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Video with Overlay */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-[#1d1e20] z-10" />
        
        <video
          ref={videoRef}
          autoPlay
          loop
          muted
          playsInline
          webkit-playsinline="true"
          x5-playsinline="true"
          poster={heroImage}
          className="w-full h-full object-cover opacity-60"
          preload="auto"
        >
          <source src="https://customer-assets.emergentagent.com/job_talentmgmt/artifacts/7ny64ssj_copy_A6B91C48-ABEB-45CC-83A5-FBF7328E1E17.MOV" type="video/mp4" />
        </video>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-20 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold mb-6 leading-tight">
            {heroTitle.split('#1').map((part, i) => (
              <React.Fragment key={i}>
                {i > 0 && <span className="text-[#c8784e]">#1</span>}
                {part}
              </React.Fragment>
            ))}
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-300 mb-12 max-w-3xl mx-auto font-light">
            {heroSubtitle}
          </p>

          <button
            onClick={handleWhatsAppClick}
            className="inline-flex items-center gap-3 bg-[#c8784e] text-black px-10 py-5 rounded-full font-semibold text-lg hover:bg-[#d89a6f] transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-[#c8784e]/50 cursor-pointer"
          >
            Postular Ahora
            <ArrowRight size={24} className="group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-[#c8784e] rounded-full mt-2 animate-bounce" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;